import { useState } from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const categories = ['Mariages', 'Anniversaires Adultes', 'Anniversaires Enfants', 'Événements Entreprise'];

const galleryData: Record<string, Array<{ src: string; alt: string }>> = {
  Mariages: [
    { src: 'https://readdy.ai/api/search-image?query=luxury%20wedding%20ceremony%20decoration%20white%20roses%20floral%20arch%20elegant%20venue%20chandeliers%20romantic%20setup%20Africa%20Abidjan%20high%20end%20photography%20beautiful%20bride&width=400&height=300&seq=evco_wed001&orientation=landscape', alt: 'Mariage élégant' },
    { src: 'https://readdy.ai/api/search-image?query=wedding%20reception%20elegant%20table%20settings%20white%20gold%20candles%20flowers%20sophisticated%20decor%20luxury%20dinner%20Abidjan%20Africa%20professional%20event&width=400&height=300&seq=evco_wed002&orientation=landscape', alt: 'Réception de mariage' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/dbe7534cbbd0a22ddb8e58c2d63836f2.jpeg', alt: 'Allée de mariage' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/e13c309307a2dbc91d946f57882e62b7.jpeg', alt: 'Photocall mariage' },
  ],
  'Anniversaires Adultes': [
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/cc48c6313703945e04cfe503229fd76d.jpeg', alt: 'Anniversaire adulte' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/eb192cdd990f040bdfe7aff31297aa3d.jpeg', alt: 'Salle décorée anniversaire adulte' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/27406113b581b91b5676e3dbbb17fd08.jpeg', alt: 'Ambiance salle anniversaire adulte' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/5b09bcb7f048d203097641d92df49e6f.jpeg', alt: 'Candy bar anniversaire' },
  ],
  'Anniversaires Enfants': [
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/a09df1f4b74e52d93fa0dde0fbe1c606.jpeg', alt: 'Décoration anniversaire enfant' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/8ad576a93b3d4bf151953b4de52d7280.jpeg', alt: 'Fête enfant colorée' },
    { src: 'https://storage.readdy-site.link/project_files/1fe20a36-8e39-416c-b295-df4be5629e5e/87415f7f-4af8-4230-92c2-52b1990fee6c_WhatsApp-Image-2026-03-17-at-1.37.44-PM-4.jpeg?v=1be31e170682b9ddc80d12b0899d1a4a', alt: 'Ambiance fête enfant' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/0616e830cf349b3cf13a93cf5803c654.jpeg', alt: 'Scène anniversaire kids' },
  ],
  'Événements Entreprise': [
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/c1787ccf192a21ac8bc2dfb8f0cd3a18.jpeg', alt: 'Gala entreprise' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/c7213a20468567e69884c4c59ac7849b.jpeg', alt: 'Lancement produit' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/882c3925a2c47a982107f14c8f0f2bad.jpeg', alt: 'Conférence corporate' },
    { src: 'https://static.readdy.ai/image/dfcab6d8a996275ea038131e02fb9f3a/46f0e167ec46736b1d17324c1a6d0ba5.jpeg', alt: 'Anniversaire entreprise' },
  ],
};

const EventGallery = () => {
  const [active, setActive] = useState('Mariages');
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="bg-brand-beige py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="h-px w-6 bg-brand-coral" />
            <span className="text-brand-coral text-xs font-medium tracking-[0.2em] uppercase">Nos Événements</span>
            <span className="h-px w-6 bg-brand-coral" />
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl text-brand-anthracite mb-4">Mariages &amp; Grands Événements</h2>
          <p className="text-brand-gray max-w-xl mx-auto text-base">
            Des créations sur mesure pour vos moments les plus précieux.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex justify-center mb-10">
          <div className="flex bg-white rounded-full p-1 gap-1">
            {categories.map((cat) => (
              <button
                key={cat}
                onClick={() => setActive(cat)}
                className={`px-5 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 cursor-pointer ${
                  active === cat
                    ? 'text-white'
                    : 'text-brand-gray hover:text-brand-anthracite'
                }`}
                style={active === cat ? { background: 'linear-gradient(135deg, #e63e8b, #f78b49)' } : {}}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Grid */}
        <div ref={ref} className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {galleryData[active].map((img, idx) => (
            <div
              key={img.alt}
              className={`relative overflow-hidden rounded-xl group cursor-pointer transition-all duration-500 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${idx * 100}ms` }}
            >
              <div className="w-full h-72 overflow-hidden">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                <span className="text-white text-xs font-medium">{img.alt}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventGallery;
